export default __webpack_public_path__ + "static/media/banner6.78b5d055.png";